// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { QuestionnaireQuestionChoiceOptionContentImageCardFragmentDoc } from './QuestionnaireQuestionChoiceOptionContentImageCard.fragment.generated';
import { QuestionnaireQuestionChoiceOptionContentIconCardFragmentDoc } from './QuestionnaireQuestionChoiceOptionContentIconCard.fragment.generated';
import { QuestionnaireQuestionChoiceOptionContentImageFragmentDoc } from './QuestionnaireQuestionChoiceOptionContentImage.fragment.generated';
import { QuestionnaireQuestionChoiceOptionContentTextFragmentDoc } from './QuestionnaireQuestionChoiceOptionContentText.fragment.generated';
export const QuestionnaireQuestionChoiceOptionContentFragmentDoc = gql`
    fragment questionnaireQuestionChoiceOptionContent on QuestionnaireQuestionChoiceOptionContent {
  ...questionnaireQuestionChoiceOptionContentImageCard
  ...questionnaireQuestionChoiceOptionContentIconCard
  ...questionnaireQuestionChoiceOptionContentImage
  ...questionnaireQuestionChoiceOptionContentText
}
    ${QuestionnaireQuestionChoiceOptionContentImageCardFragmentDoc}
${QuestionnaireQuestionChoiceOptionContentIconCardFragmentDoc}
${QuestionnaireQuestionChoiceOptionContentImageFragmentDoc}
${QuestionnaireQuestionChoiceOptionContentTextFragmentDoc}`;